module.exports = __webpack_public_path__ + "static/media/css3.6971ddc7.svg";